import React, { useState, useEffect, useRef, useMemo } from "react";
import moment from 'moment';
import DatePicker from 'react-date-picker';

// react component for creating dynamic tables
import ReactTable from "react-table";

// @material-ui/core components
import {
  Select,
  MenuItem
} from '@material-ui/core';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Financials from "components/Financials";

import Style from "assets/jss/material-dashboard-pro-react/views/actionsStyle";

// Table Data
import columns from 'tables/columns/orders.json';
import { getOrders, formatTableOrders } from 'tables/rows/orders';

const dateOptions = [
  {
    label: 'Pick Up Date',
    value: 'pickUpDate',
  },
  {
    label: 'Drop Off Date',
    value: 'dropOffDate',
  },
  {
    label: 'Created At',
    value: 'updatedAt',
  }
];

const initialDateState = {
  start: null,
  end: null,
  filterBy: ''
}

const Principles = (props) => {
  const [dateState, setDateState] = useState(initialDateState);
  const [forceUpdate, setForceUpdate] = useState(false);
  const allOrders = useRef([]);
  const tableNode = useRef(null);
  const [getAll, setGetAll] = useState(false);

  const filteredOrders = useMemo(() => {
    if (!(dateState.start || dateState.end)) return allOrders.current;

    return allOrders.current.filter(order => {

      if ((dateState.start || dateState.end) && dateState.filterBy && !(order[dateState.filterBy] || order[dateState.filterBy].split('/').length !== 3)) return false;
      // if ((!(dateState.start || dateState.end)) && order[dateState.filterBy].split('/').length !== 3) return false;

      const toJSDate = (strDate) => {
        let [month, day, year] = strDate.split('/');
        return new Date(parseInt(year), parseInt(month) - 1, parseInt(day))
      }

      if ((dateState.start || dateState.end) && dateState.filterBy) {
        const chosenDate = toJSDate(order[dateState.filterBy]);

        if (dateState.start && moment(chosenDate).isBefore(dateState.start)) return false;

        if (dateState.end && moment(chosenDate).isAfter(dateState.end)) return false;
      }

      return true;
    });
  }, [allOrders.current, dateState]);

  const handleDateChange = (date, key) => {
    setDateState(prev => ({
      ...prev,
      [key]: date
    }));
  }

  const handleDateOptionChange = (e) => {
    e.persist();
    setDateState(prev => ({
      ...prev,
      filterBy: e.target.value
    }))
  }
  
  const update = () => setForceUpdate(prev => !prev);

  const getTableOrders = (limited = true) => {
    getOrders(props.groups, limited)
      .then(snapshot => formatTableOrders(snapshot, [true, 'canceled', 'cancel requested', 'quote declined']))
      .then(data => {
        allOrders.current = data;
        setForceUpdate(prev => prev + 1);
      })
      .catch(err => console.error(err));
  }

  const getAllOrders = () => {
    if (getAll) return;

    setGetAll(true);
    getTableOrders(false)

  }

  useEffect(() => {
    getTableOrders()
  }, []);

  return (
    <React.Fragment>
      {tableNode.current && (
        <Financials orders={tableNode.current} />
      )}
      <GridContainer justify='center'>
        <GridItem xs={12}>
          <GridContainer justify='center' style={{ marginBottom: '8px' }} alignItems='center'>
            <GridItem>
              <Select
                value={dateState.filterBy}
                onChange={handleDateOptionChange}
                style={{ marginTop: '24px', width: '150px' }}
              >
                {dateOptions.map((option, i) => (
                  <MenuItem value={option.value} key={i}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </GridItem>
            <GridItem>
              <p style={{ textAlign: 'center' }}>Start</p>
              <DatePicker
                onChange={(e) => handleDateChange(e, 'start')}
                value={dateState.start}
              />
            </GridItem>
            <GridItem>
              <p style={{ textAlign: 'center' }}>End</p>
              <DatePicker
                onChange={(e) => handleDateChange(e, 'end')}
                value={dateState.end}
              />
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
      {getAll ? null : (
        <Button
          color='primary'
          onClick={getAllOrders}
        >
          GET ALL ORDERS
        </Button>
      )}
      <ReactTable
        ref={tableNode}
        data={filteredOrders}
        filterable
        defaultFilterMethod={(filter, row) => {
          const id = filter.pivotId || filter.id;
          return row[id] !== undefined
            ? (String(row[id]).toLowerCase()).includes(filter.value.toLowerCase())
            : true;
        }}
        columns={columns.columns}
        defaultPageSize={50}
        onFilteredChange={update}
        showPaginationBottom
        style={{
          color: "#000"
        }}
        className="-striped -highlight"
      />
    </React.Fragment>
  );
}

export default Principles;


// WEBPACK FOOTER //
// ./src/views/Dispatch/CancelledOrders.jsx